
.TodayTypo {
    margin: .25rem;
    padding: .25rem;
    text-align: center;
    border-radius: 14px;
    color: var(--soniq-t--global--text--color--hint--default);

    &.isToday {
        background: var(--soniq-t--global--background--color--surface--panel);
        border: solid 1px var(--soniq-t--global--border--color--accent--today--default);
    }
}
